import { useState } from 'react';
import { FilterType } from './constants';
import ScrollArrows from './ScrollArrows';

interface ContributionWidgetFiltersProps {
  onChange: React.Dispatch<React.SetStateAction<FilterType>>;
  small?: boolean;
  filtersList: readonly FilterType[];
}

const ContributionWidgetFilters: React.FC<ContributionWidgetFiltersProps> = ({
  filtersList,
  onChange,
  small,
}) => {
  const [selected, setSelected] = useState<FilterType>('Asset');

  function renderListItem(filter: FilterType, index: number) {
    return (
      <div
        key={index}
        className={`flex justify-center border border-transparent whitespace-nowrap font-medium text-sm py-2 mt-2 ${
          selected === filter
            ? 'bg-primary text-black'
            : 'bg-grey-5 text-grey-50 dark:bg-grey-90 dark:border-grey-80'
        } rounded-xl cursor-pointer px-8`}
        onClick={() => {
          setSelected(filter);
          onChange(filter);
        }}
      >
        {filter}
      </div>
    );
  }
  return small ? (
    <ScrollArrows>{filtersList.map(renderListItem)}</ScrollArrows>
  ) : (
    <div className="flex flex-col px-4">{filtersList.map(renderListItem)}</div>
  );
};

export default ContributionWidgetFilters;
